import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgMfa = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("rect", {
			width: 16,
			height: 16,
			fill: "none"
		}),
		/* @__PURE__ */ _jsxs("g", {
			clipPath: "url(#clip0_10173_1827)",
			children: [
				/* @__PURE__ */ _jsx("path", {
					d: "M13.6875 1.4375H2.3125C1.82906 1.4375 1.4375 1.82906 1.4375 2.3125V10.625C1.4375 11.1084 1.82906 11.5 2.3125 11.5H4.28125C4.40156 11.5 4.5 11.4016 4.5 11.2812C4.5 11.1609 4.40156 11.0625 4.28125 11.0625H2.3125C2.07187 11.0625 1.875 10.8656 1.875 10.625V2.96875H9.45906L10.275 3.58125C10.3122 3.60969 10.3581 3.625 10.4062 3.625H14.125V10.625C14.125 10.8656 13.9281 11.0625 13.6875 11.0625H11.7188C11.5984 11.0625 11.5 11.1609 11.5 11.2812C11.5 11.4016 11.5984 11.5 11.7188 11.5H13.6875C14.1709 11.5 14.5625 11.1084 14.5625 10.625V2.3125C14.5625 1.82906 14.1709 1.4375 13.6875 1.4375ZM10.4784 3.1875L9.6625 2.575C9.62531 2.54656 9.57937 2.53125 9.53125 2.53125H1.875V2.3125C1.875 2.07187 2.07187 1.875 2.3125 1.875H13.6875C13.9281 1.875 14.125 2.07187 14.125 2.3125V3.1875H10.4784Z",
					fill: "currentColor",
					stroke: "currentColor",
					strokeWidth: .2
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M13.0312 2.3125H12.5938C12.4734 2.3125 12.375 2.41094 12.375 2.53125C12.375 2.65156 12.4734 2.75 12.5938 2.75H13.0312C13.1516 2.75 13.25 2.65156 13.25 2.53125C13.25 2.41094 13.1516 2.3125 13.0312 2.3125Z",
					fill: "currentColor"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M11.5 2.3125H11.0625C10.9422 2.3125 10.8438 2.41094 10.8438 2.53125C10.8438 2.65156 10.9422 2.75 11.0625 2.75H11.5C11.6203 2.75 11.7188 2.65156 11.7188 2.53125C11.7188 2.41094 11.6203 2.3125 11.5 2.3125Z",
					fill: "currentColor"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M10.1875 5.375H5.8125C5.32906 5.375 4.9375 5.76656 4.9375 6.25V13.6875C4.9375 14.1709 5.32906 14.5625 5.8125 14.5625H10.1875C10.6709 14.5625 11.0625 14.1709 11.0625 13.6875V6.25C11.0625 5.76656 10.6709 5.375 10.1875 5.375ZM10.625 13.6875C10.625 13.9281 10.4281 14.125 10.1875 14.125H5.8125C5.57187 14.125 5.375 13.9281 5.375 13.6875V6.25C5.375 6.00937 5.57187 5.8125 5.8125 5.8125H10.1875C10.4281 5.8125 10.625 6.00937 10.625 6.25V13.6875Z",
					fill: "currentColor",
					stroke: "currentColor",
					strokeWidth: .2
				}),
				/* @__PURE__ */ _jsxs("g", {
					clipPath: "url(#clip1_10173_1827)",
					children: [/* @__PURE__ */ _jsx("path", {
						d: "M8.42008 8.97998L7.58008 9.81998",
						stroke: "currentColor",
						strokeWidth: .4,
						strokeLinecap: "round",
						strokeLinejoin: "round"
					}), /* @__PURE__ */ _jsx("path", {
						d: "M7.58008 8.97998L8.42008 9.81998",
						stroke: "currentColor",
						strokeWidth: .4,
						strokeLinecap: "round",
						strokeLinejoin: "round"
					})]
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M8.4375 12.8125H7.5625C7.44219 12.8125 7.34375 12.9109 7.34375 13.0312C7.34375 13.1516 7.44219 13.25 7.5625 13.25H8.4375C8.55781 13.25 8.65625 13.1516 8.65625 13.0312C8.65625 12.9109 8.55781 12.8125 8.4375 12.8125Z",
					fill: "currentColor"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M9.82023 7.95412L8.07023 7.35475C8.0243 7.33943 7.97398 7.33943 7.92805 7.35475L6.17805 7.95412C6.09055 7.98475 6.0293 8.06787 6.0293 8.16193V9.58381C6.0293 10.6294 6.65273 11.3251 7.93461 11.7101C7.9543 11.7166 7.97617 11.7188 7.99805 11.7188C8.01992 11.7188 8.03961 11.7166 8.06148 11.7101C9.34336 11.3251 9.9668 10.6294 9.9668 9.58381V8.16193C9.9668 8.06787 9.90773 7.98475 9.81805 7.95412H9.82023ZM9.53148 9.58381C9.53148 10.4172 9.05898 10.9401 8.00023 11.2704C6.94148 10.9379 6.46898 10.4151 6.46898 9.58381V8.31725L8.00023 7.79225L9.53148 8.31725V9.58381Z",
					fill: "currentColor"
				})
			]
		}),
		/* @__PURE__ */ _jsxs("defs", { children: [/* @__PURE__ */ _jsx("clipPath", {
			id: "clip0_10173_1827",
			children: /* @__PURE__ */ _jsx("rect", {
				width: 14,
				height: 14,
				fill: "none",
				transform: "translate(1 1)"
			})
		}), /* @__PURE__ */ _jsx("clipPath", {
			id: "clip1_10173_1827",
			children: /* @__PURE__ */ _jsx("rect", {
				width: 1.68,
				height: 1.68,
				fill: "none",
				transform: "translate(7.16016 8.56006)"
			})
		})] })
	]
});
const ForwardRef = forwardRef(SvgMfa);
export default ForwardRef;
